import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { NavDropdown } from "react-bootstrap";
import logo from "../../images/product-images/remove-bg/sahakar-jal.png";
import { auth } from "../../firebase-config";
import { useState, useEffect } from "react";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../../firebase-config";
import { signOut } from "firebase/auth";
const MyNavbar = () => {
  const [userId, setUserId] = useState("");
  const [numberOfPdts, setNumberOfPdts] = useState(0);
  const [emailVerified, setEmailVerified] = useState(false);

  function products() {
    auth.onAuthStateChanged(async () => {
      const currentUserInApp = auth.currentUser;
      if (currentUserInApp) {
        setUserId(currentUserInApp.uid);
        // setValid(true);
        // console.log("is Valid ? ", valid);
        console.log(auth.currentUser.emailVerified);
        if (auth.currentUser.emailVerified) setEmailVerified(true);

        const collectionRef = collection(db, currentUserInApp.uid + "+Cart");
        const data = await getDocs(collectionRef);
        console.log(data.size, "data.size in navbar");
        setNumberOfPdts(data.size);
        // return userId;
      } else {
        // setValid(false);
        // console.log("No user here App.js");
      }
    });
  }

  const signOutMine = () => {
    // window.localStorage.removeItem("isLoggedIn");
    try {
      signOut(auth);
      // return <Navigate to="/ResetPassword" />;
      // setRedirect(true);
      // console.log(redirect, "redirect");
      // renderRedirect()
      window.location.reload(true);
    } catch (error) {
      // setRedirect(false);
    }
    products();
  };

  useEffect(() => {
    products();
  });

  return (
    <span onFocus={products}>
      <Navbar collapseOnSelect expand="lg" bg="light" variant="light">
        <Container>
          <span>
            <img alt="logo" src={logo} width={120} height={60} />
          </span>
          <Navbar.Brand className="brandName">SAHAKAR JAL</Navbar.Brand>
          <div className="neumorph">
            <Navbar.Toggle
              onClick={products}
              aria-controls="responsive-navbar-nav"
            />
          </div>
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link href="/Home">Home</Nav.Link>
              <Nav.Link href="/Products">Products</Nav.Link>
              {!emailVerified && (
                <>
                  <Nav.Link href="/SignUp">Sign Up</Nav.Link>
                  <Nav.Link href="/SignIn">Sign In</Nav.Link>
                </>
              )}
            </Nav>
            {userId && emailVerified && (
              <Nav.Link onClick={signOutMine}>Sign Out</Nav.Link>
            )}
            {/* 
              <Nav>
                <NavDropdown
                  title={
                    <>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="currentColor"
                        className="bi bi-cart"
                        viewBox="0 0 16 16"
                      >
                        <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l1.313 7h8.17l1.313-7H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                      </svg>
                      <span>{numberOfPdts}</span>
                    </>
                  }
                  id="basic-nav-dropdown"
                >
                  <NavDropdown.Item href="/Cart">Go To Cart</NavDropdown.Item>
                </NavDropdown>

                <Nav.Link href="/Profile">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="currentColor"
                    className="bi bi-person"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                  </svg>
                </Nav.Link>
                </Nav>
              */}
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </span>
  );
};

export default MyNavbar;
